/** @jsx jsx */
import { jsx } from 'theme-ui';
import React from 'react';
import PortableText from '@sanity/block-content-to-react';
import { useSanityConfig } from '../../utils/useSanityConfig';
import serializers, { serializersExcerpt } from './serializers';
import ClassNames from '../group-page/classnames';
import { useLangKey } from '../../utils/lang';
import { PlayerContextProvider } from '../player/PlayerContext';
import PlayerModal from '../player/PlayerModal';

const SanityContent = ({ intlContent }) => {
	return (
		<IntlText intlContent={intlContent}>
			{({ blocks, lang, availableLangs, onChange }) => {
				if (availableLangs && availableLangs.length > 0)
					return (
						<React.Fragment>
							<ContentLangChooser availableLangs={availableLangs} value={lang} onChange={onChange} />
							<Text data={blocks} />
						</React.Fragment>
					);
				else return <Text data={blocks} />;
			}}
		</IntlText>
	);
};

const get_available_langs = (intlContent) => Object.entries(intlContent).filter(([ key, v ]) => v);

export const IntlText = ({ intlContent, children }) => {
	const { raw } = intlContent;

	if (raw) return children({ blocks: raw });

	return <WithChooser intlContent={intlContent}>{children}</WithChooser>;

	// return (
	// 	<React.Fragment>
	// 		<ContentLangChooser availableLangs={availableLangs} value={lang} onChange={setLang} />
	// 		<Text data={l[1]} isExcerpt={isExcerpt} />
	// 	</React.Fragment>
	// );
};

const WithChooser = ({ intlContent, children }) => {
	const availableLangs = get_available_langs(intlContent);
	const [ lang, setLang ] = React.useState(availableLangs[0]);

	const blocks = lang && lang[1];

	return children({ blocks, lang, availableLangs, onChange: setLang });
};

export const Text = ({ data, isExcerpt }) => {
	const { sanityDataset, sanityProjectId } = useSanityConfig();
	const sanityConfig = {
		projectId: sanityProjectId,
		dataset: sanityDataset
	};

	return (
		<PlayerContextProvider>
			<PlayerModal />
			<PortableText
				renderContainerOnSingleChild={true}
				blocks={data}
				serializers={isExcerpt ? serializersExcerpt : serializers}
				{...sanityConfig}
			/>
		</PlayerContextProvider>
	);
};

export default SanityContent;

export const ContentLangChooser = ({ availableLangs, value, onChange, isExcerpt }) => {
	const msg = {
		de: 'Dieser Inhalt ist Verfügbar in:',
		fr: 'Ce contenu est disponible en :',
		en: 'This content is available in:',
		es: 'Este contenido está disponible en:'
	};

	const lang_name = {
		de: 'German',
		fr: 'French',
		es: 'Spanish',
		en: 'English'
	};

	const langKey = useLangKey();

	const l = value ? value : availableLangs[0];

	const selected = { fontWeight: '800' };

	const style = isExcerpt ? { padding: '0.2em', my: '0.2em' } : { padding: '1em' };

	return (
		<p sx={{ backgroundColor: '#ededed', cursor: 'default', ...style }} onClick={(e) => e.preventDefault()}>
			{msg[langKey]}{' '}
			{availableLangs.map((ll, index) => {
				const key = ll[0].replace('raw', '').toLowerCase();
				const isSelected = ll[0] === l[0];
				return (
					<React.Fragment>
						{index === 0 ? '' : ','}{' '}
						<span
							sx={{
								...(isSelected ? selected : undefined),
								cursor: isSelected ? 'default' : 'pointer',
								color: '#00f'
							}}
							onClick={(e) => {
								onChange(ll);
							}}
						>
							{lang_name[key]}
						</span>
					</React.Fragment>
				);
			})}{' '}
			<san />
		</p>
	);
};
